import React, { useEffect, useState } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { generatePath } from "react-router";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { observer } from "mobx-react-lite";

import Container from "components/Layout/Container/Container";
import Header from "components/Layout/Header/Header";
import Page from "components/Layout/Page/Page";
import PublishButton from "components/PublishButton/PublishButton";
import Placeholder from "components/Placeholder/Placeholder";
import ROUTES from "navigation/routes";
import withGlobalPopup, {
  GlobalPopupProps,
} from "components/Popup/withGlobalPopup";
import {
  withGlobalSnackbar,
  SnackbarContextProps,
} from "services/snackbar/snackbarContext";
import ManualBadgeCard from "./ManualBadgeCard/ManualBadgeCard";
import { PageControl } from "./styles";
import ManualBadgeStore from "stores/ManualBadgeStore";

type Props = GlobalPopupProps & SnackbarContextProps & RouteComponentProps & {};

const InAppManualBadges: React.FC<Props> = (props: Props) => {
  const [badgesListIsEmpty, setBadgesListIsEmpty] = useState(false);
  const [badges, setBadges] = useState([]);

  const fetchBadges = async () => {
    try {
      await ManualBadgeStore.fetchManualBadgeList({});
      if (ManualBadgeStore.manualBadges.length === 0) {
        setBadgesListIsEmpty(true);
      } else {
        setBadges(ManualBadgeStore.manualBadges);
        setBadgesListIsEmpty(false);
      }
    } catch (error) {
      console.error("Failed to fetch manual badges:", error);
    }
  };

  useEffect(() => {
    fetchBadges();
  }, []);

  const onAddBadge = () => {
    props.history.push({
      pathname: generatePath(ROUTES.IN_APP_MANUAL_BADGES_DETAILS),
      state: { editMode: true },
    });
  };

  const onDetailsClick = (manualBadge: any) => {
    props.history.push({
      pathname: generatePath(ROUTES.IN_APP_MANUAL_BADGES_DETAILS, {
        manualBadgeId: manualBadge.id,
      }),
      state: {
        editMode: false,
      },
    });
  };

  const onEdit = (manualBadge: any) => {
    props.history.push({
      pathname: generatePath(ROUTES.IN_APP_MANUAL_BADGES_DETAILS, {
        manualBadgeId: manualBadge.id,
      }),
      state: {
        editMode: true,
      },
    });
  };

  const onPublish = async (manualBadgeId: number, currentStatus: string) => {
    try {
      const status = currentStatus === "Draft" ? "Published" : "Draft";
      await ManualBadgeStore.updateManualBadgeStatus(manualBadgeId, status);
    } catch (error) {
      console.error("Error al actualizar el estado del manual badge:", error);
    }
  };
  return (
    <Container header={<Header controls={<PublishButton />} />}>
      <Page
        title="Manual Badges"
        controls={
          <PageControl>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onAddBadge}
            >
              Add Badge
            </Button>
          </PageControl>
        }
        isLoading={ManualBadgeStore.isUpdating}
      >
        {badgesListIsEmpty ? (
          <Placeholder height={280} width={280} text={"No badges added yet."} />
        ) : (
          badges.map(badge => (
            <ManualBadgeCard
              key={badge.id}
              title={badge.title}
              successful={badge.successfulUsersAmount}
              publishStatus={badge.PublishStatus}
              image={badge.fileUrl}
              date={badge.displayDate}
              onDetailsClick={() => onDetailsClick(badge)}
              onEdit={() => onEdit(badge)}
              onPublish={() => onPublish(badge.id, badge.PublishStatus)}
            />
          ))
        )}
      </Page>
    </Container>
  );
};

export default withGlobalPopup(
  withGlobalSnackbar(withRouter(observer(InAppManualBadges))),
);
